import type { SyntheticEvent } from 'react'
import { cmsImageFallbackUrl } from './cms-image'

/** Guard against an endless error loop: derivative → original → legacy original. */
const MAX_RETRIES = 3

/**
 * <img> onError handler used across the public site.
 *
 * Walks the fallback chain from `cmsImageFallbackUrl` (optimised derivative →
 * stored original → legacy `-original.jpg`). When nothing is left, the image is
 * hidden so a broken 404 tile is never shown. With `hideParent`, the closest
 * element matching that selector is hidden instead (e.g. a gallery tile).
 */
export function handleCmsImageError(
  e: SyntheticEvent<HTMLImageElement>,
  hideParent?: string,
): void {
  const img = e.currentTarget
  const tried = Number(img.dataset.fallbackStep ?? '0')
  const fallback = cmsImageFallbackUrl(img.currentSrc || img.src)

  if (fallback && tried < MAX_RETRIES) {
    img.dataset.fallbackStep = String(tried + 1)
    // A srcset would otherwise win over the fallback src.
    img.removeAttribute('srcset')
    img.removeAttribute('sizes')
    img.src = fallback
    return
  }

  const target = hideParent ? (img.closest(hideParent) as HTMLElement | null) : img
  if (target) target.style.display = 'none'
}
